export default __webpack_public_path__ + "static/media/ezzam-artworkinfo1.b3e68ba2.png";